import type { suchuangModelConfig, StatusMapping } from './types';
import { googleConfigs } from './configs/google';
import { openaiConfigs } from './configs/openai';

/**
 * suchuang 状态映射配置（所有模型统一使用）
 */
export const suchuangStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'data.id',
    /** 状态字段路径 */
    statePath: 'data.status',
    /** 成功状态值 */
    success: [2],
    /** 失败状态值 */
    failed: [3],
    /** 处理中状态值 */
    processing: [0, 1],
    /** 图像 URL 字段路径 */
    imageUrlPath: 'data.result[0]',
    /** 错误信息字段路径 */
    errorPath: 'data.message',
};

/**
 * 模型配置映射
 */
export const suchuangModelConfigs: Record<string, suchuangModelConfig> = {
    ...googleConfigs,
    ...openaiConfigs,
};